module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAARCAYAAADtyJ2fAAABHklEQVQokY2SzSqFURSGX6cchVIckzNVLgFlLDMDmSll4BK4AooL4A5kIiZ+MjBBmTAwEyZcAflJokfbeXf2+drfx1t7sNd6n9Xaey0BxTMFnAIfwCdw7librwgt0dIjsA3sAE+OLZaBozacAP1JvAGcOTeWAzeBd6CZab/p3FYOvAGOM1A8R8BdvNf0q05JbyrXs6SumE3BW0kjkuoZNMTG7WkpaWXWH7CaaXPNubncGzuAfRv2XCgYDxzbBWplc+xO4FShUL1sjj3AurelqC9gw4XbwAHgyu7Q2jQwBAwDMx5F0CXQl4KHrjpfMceF5P0/4KQDyxVQPCv2TsRVewV6/wEGz0tgwuXerf4Fpav3EDZnUNJ1xaoVdSGp8Q3rGI8XzQerPwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/khgl.png
// module id = Q3t9
// module chunks = 1